import React from "react";
import { Table } from "reactstrap";
import { resolveAssetNameDisplay } from "../../../../utils/otherValueDisplay";

const ICTTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No ICT equipment recorded.</p>;
    }

    // Calculate unique reference numbers once for color assignment
    const refNumbers = [...new Set(assets.map(asset => asset.reference_number || asset.valuation_ref || "").filter(Boolean))];
    
    // Color palette for alternating groups
    const groupColors = [
        "#e8f0f5", // Light blue-gray - for first reference_number group
        "#ffffff", // White - for second reference_number group
    ];

    return (
        <Table responsive hover bordered>
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
                <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Reference Number</th>
                    <th>Barcode</th>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Acquisition Date</th>
                    <th>Valuer</th>
                    <th>Status</th>
                    <th>Condition</th>
                    <th>Remark</th>
                </tr>
            </thead>
            <tbody>
                {assets.map((a, index) => {
                    const condition = a.observed_condition_name || a.observed_condition || "Good";
                    
                    // Derive valuer name from related valuation (if present)
                    const valuation = a.asset_valuation || a.assetValuation || a.valuation;
                    const valuer = valuation?.valuer_user || valuation?.valuerUser;
                    const valuerName =
                        a.valuer_name || a.valuerName ||
                        (valuer
                            ? [
                                  valuer.first_name || valuer.firstName || "",
                                  valuer.middle_name || valuer.middleName || "",
                                  valuer.last_name || valuer.lastName || "",
                              ]
                                  .filter(Boolean)
                                  .join(" ")
                            : "-");
                    
                    // Get current reference number
                    const currentRef = a.reference_number || a.valuation_ref || "";
                    // Get color index for this reference number group
                    const refIndex = refNumbers.indexOf(currentRef);
                    const colorIndex = refIndex >= 0 ? (refIndex % groupColors.length) : 1;
                    const rowBgColor = currentRef ? groupColors[colorIndex] : "#ffffff";
                    
                    // Add custom CSS class for persistent background
                    const rowClassName = currentRef ? `ref-group-${colorIndex}` : "";
                    
                    // Style for the row: background color only
                    const rowStyle = {
                        backgroundColor: rowBgColor
                    };
                    
                    return (
                        <tr key={a.id} className={rowClassName} style={rowStyle}>
                            <td className="fw-bold text-muted">{index + 1}</td>
                            <td>{a.reference_number || a.valuation_ref || "-"}</td>
                            <td>{a.barcode || "-"}</td>
                            <td><strong>{resolveAssetNameDisplay(a)}</strong></td>
                            <td>{a.location || "-"}</td>
                            <td>{a.acquisition_date ? new Date(a.acquisition_date).toLocaleDateString() : "-"}</td>
                            <td>{valuerName || "-"}</td>
                            <td>{a.status || a.valuation_status || "-"}</td>
                            <td>{condition}</td>
                            <td>{a.remark || "-"}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default ICTTab;
